var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (filter) {pug_mixins["predicate"] = pug_interp = function(predicate, isFirst){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"column\"\u003E";
if ((!isFirst)) {
pug_html = pug_html + "\u003Cspan class=\"filterand\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + (pug.escape(null == (pug_interp = predicate.i18n.property) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"filter_operator\"\u003E" + (pug.escape(null == (pug_interp = predicate.i18n.operator) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
// iterate predicate.i18n.values
;(function(){
  var $$obj = predicate.i18n.values;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
if ((index != 0)) {
pug_html = pug_html + ",";
}
pug_html = pug_html + "\u003Cspan class=\"filterValue\"\u003E" + (pug.escape(null == (pug_interp = ' '+val) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
if ((index != 0)) {
pug_html = pug_html + ",";
}
pug_html = pug_html + "\u003Cspan class=\"filterValue\"\u003E" + (pug.escape(null == (pug_interp = ' '+val) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

if ((!!predicate.i18n.moreText)) {
pug_html = pug_html + ",\u003Cspan class=\"type-bold\"\u003E" + (pug.escape(null == (pug_interp = ' '+predicate.i18n.moreText) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
};
var predicates = filter.$and || filter.$or
pug_html = pug_html + "\u003Cspan class=\"humanized\"\u003E";
// iterate predicates
;(function(){
  var $$obj = predicates;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var predicate = $$obj[index];
pug_mixins["predicate"](predicate, index === 0);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var predicate = $$obj[index];
pug_mixins["predicate"](predicate, index === 0);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fspan\u003E";}.call(this,"filter" in locals_for_with?locals_for_with.filter:typeof filter!=="undefined"?filter:undefined));;return pug_html;};
module.exports = template;